import { render, staticRenderFns } from "./JourneyMetadata.vue?vue&type=template&id=ff6800f2&"
import script from "./JourneyMetadata.vue?vue&type=script&lang=js&"
export * from "./JourneyMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports